import {
  IconWithTextLockup,
  type IconWithTextLockupProps,
} from '@deckee/deck-hand';

export default IconWithTextLockup;
export type { IconWithTextLockupProps };
